import React from 'react';

import { List } from '@common/typescript/objects/List';

import {
	ImageCapture,
	blockRichImgCaptures,
	blockRichText,
	blockRichTitle,
	homeLinkItems,
	homeLinkRichItems,
	homeLinkRichTitle,
	homeSliderTesTitle,
	homeSliderVetTitle,
} from '@app/components/Pages/Home/homeContent';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import BlockRich from '@app/components/UI/LinkBlock/BlockRich';
import LinkBlockIcons from '@app/components/UI/LinkBlock/LinkBlockIcons';
import LinkBlockRich from '@app/components/UI/LinkBlock/LinkBlockRich';
import MastheadHero from '@app/components/UI/MastHead/MastheadHero';
import SliderTes from '@app/components/UI/Slider/SliderTes';
import SliderVet from '@app/components/UI/Slider/SliderVet';
import bohdi from '@app/content/BlockRichResources/Bohdi5-fixed.jpg';
import itsTime from '@app/content/BlockRichResources/How-will-I-know-its-time.jpg';
import blog from '@app/content/BlockRichResources/Roger-UngarDumont-NJ.jpg';
import { BaseContentPage } from '@app/objects/ContentPage';
import { Testimonials } from '@app/objects/Testimonials';
import { Veterinarian } from '@app/objects/Veterinarian';
import { HomePageContent } from '@app/objects/pageContent/HomePageContent';

const imgHome = require('@app/content/homepage.png');
const imgHomeWebp = require('@app/content/homepage.webp');

export interface PageProps extends BaseContentPage {
	veterinarians: List<Veterinarian>;
	testimonials: List<Testimonials>;
	stateName: string;
	content: HomePageContent;
}

const Home: React.FC = () => {
	return (
		<HelmetProvider<PageProps>>
			{(page) => (
				<div className="home-page">
					<MastheadHero
						title={page.content.header}
						imageSrc={imgHome}
						imageSrcWebp={imgHomeWebp}
						imageAlt="In-home euthanasia"
						imageWidth={624}
						imageHeight={554}
					/>
					<LinkBlockIcons items={homeLinkItems} />
					<SliderVet subtitle="Our veterinarians" title={homeSliderVetTitle} location="Viewing Lap of Love Vets" items={page.veterinarians.list} />
					<LinkBlockRich
						title={homeLinkRichTitle}
						subtitle="Our services"
						images={[
							{ title: 'Dr. Dani & Fiona', src: require('@app/content/daniAndFiona.jpg'), alt: 'Veterinary pet hospice' },
							{ title: 'Dr. Mary & Serissa', src: require('@app/content/maryAndSerissa.jpg'), alt: 'Pet quality of life' },
							{ title: 'Weezy, Port Charlotte, FL', src: require('@app/content/street_dog.png'), alt: 'Pet loss support' },
						]}
						links={homeLinkRichItems}
						srcYouTube="https://www.youtube.com/embed/7kZkKVy2v9g?si=Zt9tKSMIcMjakzha"
					/>
					<SliderTes title={homeSliderTesTitle} location="Viewing Lap of Love Testimonials" sliderTesItemContent={page.testimonials.list} />

					<BlockRich
						title={blockRichTitle}
						text={blockRichText}
						blockClassName="link-block-rich_modern"
						images={[
							{
								title: (
									<ImageCapture
										name={blockRichImgCaptures[2].name}
										town={blockRichImgCaptures[2].town}
										title={blockRichImgCaptures[2].title}
									/>
								),
								src: itsTime,
								link: '/how-will-i-know-it-is-time',
								alt: 'When to put a dog down',
							},
							{
								title: (
									<ImageCapture
										name={blockRichImgCaptures[1].name}
										town={blockRichImgCaptures[1].town}
										title={blockRichImgCaptures[1].title}
									/>
								),
								src: blog,
								style: { objectPosition: 'left top' },
								link: '/blog',
								alt: 'Home pet euthanasia',
							},

							{
								title: (
									<ImageCapture
										name={blockRichImgCaptures[0].name}
										town={blockRichImgCaptures[0].town}
										title={blockRichImgCaptures[0].title}
									/>
								),
								src: bohdi,
								link: '/resource-center/symptom-management',
								alt: 'Cat euthanasia',
							},
						]}
						subtitle="Helpful resources"
					/>
				</div>
			)}
		</HelmetProvider>
	);
};

export default Home;
